// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

const setupMobileNav = () => {
  const toggle = document.querySelector("[data-mobile-nav-toggle]")
  const panel = document.querySelector("[data-mobile-nav-panel]")
  if (!toggle || !panel) return
  if (toggle.dataset.mobileNavBound === "true") return
  toggle.dataset.mobileNavBound = "true"

  const closeMenu = () => {
    panel.classList.add("hidden")
    toggle.setAttribute("aria-expanded", "false")
  }

  const openMenu = () => {
    panel.classList.remove("hidden")
    toggle.setAttribute("aria-expanded", "true")
  }

  toggle.addEventListener("click", () => {
    if (panel.classList.contains("hidden")) {
      openMenu()
      return
    }
    closeMenu()
  })

  panel.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeMenu)
  })

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeMenu()
  })
}

document.addEventListener("turbo:load", setupMobileNav)
